<div class="card-wrapper">
  <div class="card-header">
    <div class="card-header-left">
      <span class="card-title"
        >{{ title() }} <span class="card-subtitle">{{ subtitle() }}</span></span
      >
    </div>
    <div class="card-header-right">
      <ng-content select="[cardHeaderRight]"></ng-content>
    </div>
  </div>

  <div class="card-content">
    <ng-content></ng-content>
  </div>
</div>
